import styled from "styled-components";
import { Link } from "react-router-dom";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 20px 32px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
`;

export const CardWithHeader = styled(Card)`
  padding-top: 32px;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;

export const CardHeaderLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  text-decoration: none;
`;

export const CardHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1 0;
  min-width: 0;
`;

export const CardTitle = styled.h2`
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #0f172a;
`;

export const CardDescription = styled.p`
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #475569;
`;

export const Divider = styled.hr`
  width: 100%;
  margin: 0;
  border: none;
  border-top: 1px solid #e2e8f0;
`;

export const RowLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 16px;
  box-sizing: content-box;
  width: 100%;
  padding: 16px 12px;
  margin: -8px -12px;
  border-radius: 8px;
  text-decoration: none;
  transition: background 0.15s ease;

  & > *:first-child {
    flex-shrink: 0;
  }

  &:hover {
    background: #f1f5f9;
  }
`;

export const RowIcon = styled.span`
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: ${(p) => p.$color || "#475569"};
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const RowTitle = styled.span`
  flex: 1 1 0;
  min-width: 0;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #0f172a;
`;

export const Chevron = styled.span`
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: #a3a3a3;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const CategoryRowContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1 0;
  min-width: 0;
`;

export const Meta = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #475569;
`;

export const MetaIcon = styled.span`
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
